import { PagingParameters } from "@/api/dtos";
import {
  DashboardListView,
  readDashboardListViewPreference,
  saveDashboardListScroll,
} from "@/lib/dashboardListScrollRestore";
import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

type UseDashboardListNavigateParams = {
  listKey: string;
  pagination: PagingParameters;
  viewStorageKey: string;
};

export function useDashboardListNavigate({
  listKey,
  pagination,
  viewStorageKey,
}: UseDashboardListNavigateParams) {
  const navigate = useNavigate();
  const location = useLocation();
  const viewStorageKeyForView = `${viewStorageKey}-view`;

  const navigateToFiche = useCallback(
    (detailPath: string, entityId: string) => {
      const view: DashboardListView =
        readDashboardListViewPreference(viewStorageKeyForView);

      saveDashboardListScroll(entityId, {
        listKey,
        page: pagination.page,
        pageSize: pagination.pageSize,
        view,
      });
      navigate(`${detailPath}${location.search}`);
    },
    [
      listKey,
      location.search,
      navigate,
      pagination.page,
      pagination.pageSize,
      viewStorageKeyForView,
    ],
  );

  return { navigateToFiche };
}
